import { transport } from 'config/transport';

export function callApiGetListOfDanhMucDuChiCongDoan() {
    return transport.get(`/congdoan/thuchi/chicongdoan/danhmuc/duchicongdoan`);
}
